import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class FoldersTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public folders!: any[]

  get headers() {
    return [
      { text: 'Name', value: 'name' },
      { text: 'Aktionen', value: 'action', sortable: false },
    ]
  }

  private edit(folder: any) {
    this.$emit('edit', folder)
  }

  private deleteFolder(folder: any) {
    if (confirm('Soll der Ordner wirklich gelöscht werden?')) {
      this.$emit('delete', folder)
    }
  }
}
